/* eslint no-console: "off"*/
import { COMPONENT_NAME, LOG_LEVEL, ENV } from './settings';

function getCustomLogger(moduleName) {
  let prefixMessage = `[${COMPONENT_NAME}]`;
  const debug_mode = LOG_LEVEL === 'debug' || ENV !== 'prod';

  if (moduleName) {
    prefixMessage = `${prefixMessage}[${moduleName}]`;
  }

  const customLogs = {
    log: (...args) => {
      if (debug_mode) {
        console.log(prefixMessage, ...args);
      }
    },
    info: (...args) => {
      if (debug_mode) {
        console.info(prefixMessage, ...args);
      }
    },
    debug: (...args) => {
      if (debug_mode) {
        console.debug(prefixMessage, ...args);
      }
    },
    warn: (...args) => {
      console.warn(prefixMessage, ...args);
    },
    error: (...args) => {
      console.error(prefixMessage, ...args);
    },
  };

  return Object.assign({}, console, customLogs);
}

export default getCustomLogger;
